import { useQuery } from 'react-query';
import quoterApiInstance from '../../api/quoterApiInstance';
import { QUERY_KEYS, DASHBOARD_QUERY_CONFIG } from '../../constants/reactQuery';

export const FAVORITE_PLAN_METRICS = ['total', 'used', 'deleted', 'updated'];
export const FAVORITE_PLAN_PERIODS = ['week', 'month'];

const fetchFavoritePlanMetric = async (metric, period) => {
    const { data } = await quoterApiInstance.get(`/my-favorite-plans/statistics/metrics/${metric}`, {
        params: { period },
    });
    return data.data;
};

export const useFavoritePlanMetrics = (metric, period = 'month', options = {}) => {
    return useQuery(
        QUERY_KEYS.favoritePlanMetrics.detail(metric, period),
        () => fetchFavoritePlanMetric(metric, period),
        {
            ...DASHBOARD_QUERY_CONFIG,
            enabled: Boolean(metric),
            onError: (error) => {
                console.error('Error fetching favorite plan metric:', error);
            },
            ...options,
        }
    );
};

export default useFavoritePlanMetrics;
